import React, { useState } from "react";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import { Button } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import getNameByID from "../../../../../functions/getNameByID";
import { StaffuseAuth } from "../../../../security/StaffuseAuth";

function Notes({ Attendee, setAttendee, Staff }) {
  const { logout } = StaffuseAuth();

  let NotesArray = ["DateTime", "Note", "Staff_ID"];
  // Function to handle adding a new note
  const [newNote, setNewNote] = useState("");
  // Function to handle adding a new note
  const handleNoteChange = (event) => {
    setNewNote(event.target.value);
  };
  // Function to handle adding a new note
  const handleSubmitNote = () => {
    // Check if the Attendee has notes and if it is an array
    if (Attendee && Attendee.Notes && Array.isArray(Attendee.Notes)) {
      const updatedNotes = [
        ...Attendee.Notes,
        {
          DateTime: new Date().toISOString(),
          Note: newNote,
          Staff_ID: localStorage.getItem("_id"),
        },
      ];
      setAttendee({ ...Attendee, Notes: updatedNotes });
      setNewNote(""); // Clear the input field after submission
    }
    // If the Attendee does not have notes
    else {
      setAttendee({
        ...Attendee,
        Notes: [
          {
            DateTime: new Date().toISOString(),
            Note: newNote,
            Staff_ID: localStorage.getItem("_id"),
          },
        ],
      });
      setNewNote(""); // Clear the input field after submission
    }
  };

  return (
    <section>
      <h2>Notes</h2>
      <TableContainer
        component={Paper}
        sx={{
          width: "100%",
          margin: "0 auto",
          overflow: "auto",
        }}
      >
        <Table
          aria-label="simple table"
          sx={{
            border: "1px solid #e0e0e0",
            tableLayout: "fixed",
          }}
        >
          <TableHead>
            <TableRow>
              {NotesArray.map((NotesOption, index) => (
                <TableCell
                  key={index} // Add a unique key prop
                  className="tableCellHeader" // Add this line to include the CSS class
                  align="left"
                  style={{
                    position: "sticky",
                    Top: 0,
                    zIndex: 1,
                    fontWeight: "bold", // Make Text bold
                    padding: "8px", // Adjust padding as needed To make cells smaller
                  }}
                >
                  {NotesOption}
                </TableCell>
              ))}
              <TableCell
                className="tableCellHeader" // Add this line to include the CSS class
                align="left"
                style={{
                  position: "sticky",
                  Top: 0,
                  zIndex: 1,
                  fontWeight: "bold", // Make Text bold
                  padding: "8px", // Adjust padding as needed To make cells smaller
                }}
              >
                Staff Name
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {Attendee && Attendee.Notes && Array.isArray(Attendee.Notes) ? (
              Attendee.Notes.map((Note, index) => (
                <TableRow
                  key={index}
                  sx={{
                    "&:hover": {
                      backgroundColor: "rgba(169, 169, 169, 0.8)", // Dark grey color
                      "& .MuiTableCell-root": {
                        padding: "8px",
                        wordWrap: "break-word",
                        overflowWrap: "break-word", // Adjust padding here to make cells smaller
                      },
                    },
                  }}
                >
                  {NotesArray.map((NoteOption, index) => (
                    <TableCell
                      key={index} // Add a unique key prop
                      component="th"
                      scope="row"
                      sx={{
                        padding: "8px",
                        wordWrap: "break-word",
                        overflowWrap: "break-word",
                      }}
                    >
                      {Note[NoteOption]}
                    </TableCell>
                  ))}
                  <TableCell
                    component="th"
                    scope="row"
                    sx={{
                      padding: "8px",
                      wordWrap: "break-word",
                      overflowWrap: "break-word",
                    }}
                  >
                    {getNameByID(Staff, Note.Staff_ID, "Username")}
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <></>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <div style={{ marginTop: "20px" }}>
        <TextField
          label="New Note"
          variant="outlined"
          fullWidth
          value={newNote}
          onChange={handleNoteChange}
          sx={{ marginBottom: "10px" }}
          InputProps={{
            style: {
              backgroundColor: "white",
            },
          }}
        />
        <Button variant="contained" color="primary" onClick={handleSubmitNote}>
          Submit Note
        </Button>
      </div>
    </section>
  );
}

export default Notes;
